"use strict";

import * as React from 'react';
/**
 * Context which holds the route prop for a screen.
 */
export const NavigationContainerRefContext = /*#__PURE__*/React.createContext(undefined);
//# sourceMappingURL=NavigationContainerRefContext.js.map